import { inject, Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpInterceptorFn,
    HttpHeaders,
    HttpHandlerFn
} from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';
import { FirebaseAuthService } from '../firebase/firebase-auth.service';

// export const buildNoTokenHeaders: HttpHeaders = () => {
//     const headers = new HttpHeaders({ 'Authorization': '' });
//     return headers;
// }

export const tokenInterceptorFn: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn) => {
    const auth = inject(FirebaseAuthService);
    if (request.headers.has('Authorization') || request.url.indexOf('./assets/') >= 0) {
        return next(request);
    } else {
        return auth.getUserIdToken().pipe(
            take(1),
            switchMap((token: any) => {
                // console.log(token);
                if (token) {
                    request = request.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
                }
                return next(request).pipe(
                    catchError(response => {
                        console.log(`Token intercept STATUS: ${response.status}`);
                        if (response.status === 401 || response.status === 403 || response.status === 404) {
                            return next(request.clone({ setHeaders: { "Authorization": `Bearer ${token}` } }));
                        } else {
                            const err =
                                (response && response.error && response.error.reason && (response.error.reason.length > 0 || response.error.reason !== '') ?
                                    response.error.reason :
                                    response.error.message
                                );
                            return throwError(() => new Error(err));
                        }
                    })
                )
            })
        );
    }
}

// }
